import React from 'react';

interface DropDownCustomProps {
  SelectedComponent: React.ElementType;
  ItemComponent: React.ElementType;
  onChange: (value: any) => void;
  items: any[];
  defaultValue?: any;
}

export default function DropDownCustom({
  SelectedComponent,
  ItemComponent,
  onChange,
  items,
  defaultValue,
}: DropDownCustomProps) {
  const [selected, setSelected] = React.useState(defaultValue);
  const [open, setOpen] = React.useState(false);

  return (
    <button
      className="relative cursor-pointer"
      onClick={() => setOpen(!open)}
      onBlur={() => setOpen(false)}
    >
      <SelectedComponent {...selected} />
      {open && (
        <div className="absolute -left-6 z-10 mt-1 rounded-sm bg-white shadow-lg">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex cursor-pointer items-center justify-between rounded-sm py-2 px-4 hover:bg-gray-200"
              onClick={() => {
                setSelected(item);
                onChange(item);
                setOpen(false);
              }}
            >
              <ItemComponent {...item} />
            </div>
          ))}
        </div>
      )}
    </button>
  );
}
